import React from "react";
import { connect } from "react-redux";

import { EditableRow } from "./row/editableRow";
import { ReadOnlyRow } from "./row/readOnlyRow"


export const EmptyRegisterTableBody = ({ numTableColumns }) => (
  <tbody>
      <tr>
          <td colSpan={2} className="u-br-none">
              There are no matching rows.
          </td>
          <td colSpan={numTableColumns - 2}>
              &nbsp;
          </td>
        </tr>
  </tbody>
);


const _ReadOnlyRegisterTableBody = ({ rows, rowKeys }) => (
    <tbody>
        { rowKeys.map((rowKey) => <ReadOnlyRow key={ rowKey } rowKey={ rowKey } row={ rows[rowKey] } />) }
    </tbody>
);

export const ReadOnlyRegisterTableBody = connect((state) => ({ rows: state.mutableBaseData.rows }))(_ReadOnlyRegisterTableBody);


export const EditableRegisterTableBody  = ({ rowKeys }) => {
    return (
        <tbody>
            { rowKeys.map((rowKey) => {
                return <EditableRow key={ rowKey } rowKey={ rowKey } />
            })}
        </tbody>
    );
};

const _AddedRowsTableBody = ({ addedRows }) => (
    <tbody>
        {Object.keys(addedRows).map(rowKey => {
            return <EditableRow key={rowKey} rowKey={rowKey} />
        })}
    </tbody>
);

export const AddedRowsTableBody = connect((state) => ({
    addedRows: state.mutableEditing.addedRows,
}))(_AddedRowsTableBody);
